"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
require("cross-fetch/polyfill");
var form_urlencoded_1 = require("form-urlencoded");
var serialize;
if (typeof btoa === "undefined") {
    var Buffer_1 = require("buffer").Buffer;
    serialize = function (str) { return new Buffer_1(str, "binary").toString("base64"); };
}
else {
    serialize = btoa;
}
var BaseLoginManager = /** @class */ (function () {
    function BaseLoginManager(storage, endpoint, secret, client, scopes, additionalParams) {
        this.storage = storage;
        this.endpoint = endpoint;
        this.secret = secret;
        this.client = client;
        this.scopes = scopes;
        this.additionalParams = additionalParams;
        this.callbacks = [];
        this.refreshTokenCallbacks = [];
        this.isRefreshingToken = false;
    }
    BaseLoginManager.prototype.trySignIn = function (username, password) {
        return this.acquireToken(this.buildSignInRequest(username, password));
    };
    BaseLoginManager.prototype.trySignInWithFacebook = function (accessToken) {
        return this.acquireToken(this.buildSignInWithFacebookRequest(accessToken));
    };
    BaseLoginManager.prototype.tryRefreshToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.storage.getToken()];
                    case 1:
                        token = _a.sent();
                        if (!(token !== null)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.tryRefreshTokenInternal(token)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3: return [2 /*return*/, null];
                }
            });
        });
    };
    BaseLoginManager.prototype.tryRefreshTokenInternal = function (token) {
        var _this = this;
        if (!this.isRefreshingToken) {
            this.isRefreshingToken = true;
            this.acquireToken(this.buildRefreshRequest(token)).then(function (result) {
                _this.isRefreshingToken = false;
                _this.refreshTokenCallbacks.forEach(function (c) { return c(result.type === "success"); });
                _this.refreshTokenCallbacks = [];
            });
        }
        return new Promise(function (resolve) {
            _this.refreshTokenCallbacks.push(resolve);
        });
    };
    BaseLoginManager.prototype.onChange = function (callback) {
        this.callbacks.push(callback);
    };
    BaseLoginManager.prototype.removeOnChange = function (callback) {
        var idx = this.callbacks.indexOf(callback);
        if (idx !== -1) {
            this.callbacks.splice(idx, 1);
        }
    };
    BaseLoginManager.prototype.acquireToken = function (init) {
        return __awaiter(this, void 0, void 0, function () {
            var result, tokenResult, expDate, token, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 7, , 8]);
                        return [4 /*yield*/, fetch(this.endpoint + "/connect/token", init)];
                    case 1:
                        result = _a.sent();
                        if (!!result.ok) return [3 /*break*/, 4];
                        if (!(result.status === 400)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.signOut()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/, { type: "failure" }];
                    case 4: return [4 /*yield*/, result.json()];
                    case 5:
                        tokenResult = _a.sent();
                        expDate = new Date();
                        expDate.setSeconds(new Date().getSeconds() + tokenResult.expires_in);
                        return [4 /*yield*/, this.storage.storeToken({
                                token: tokenResult.access_token,
                                refreshToken: tokenResult.refresh_token,
                                expirationDate: expDate
                            })];
                    case 6:
                        token = _a.sent();
                        this.notify(true);
                        return [2 /*return*/, { type: "success" }];
                    case 7:
                        e_1 = _a.sent();
                        console.warn("Cannot call Auth server, error: ", e_1);
                        return [2 /*return*/, { type: "networkError" }];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    BaseLoginManager.prototype.buildSignInRequest = function (username, password) {
        var data = {
            "grant_type": "password",
            "scope": this.scopes,
            "username": username,
            "password": password
        };
        if (this.additionalParams) {
            data = __assign(__assign({}, this.additionalParams), data);
        }
        var params = form_urlencoded_1.default(data);
        return {
            method: "POST",
            headers: this.prepareHeaders(),
            body: params
        };
    };
    BaseLoginManager.prototype.buildSignInWithFacebookRequest = function (accessToken) {
        var data = {
            "grant_type": "facebook",
            "scope": this.scopes,
            "assertion": accessToken
        };
        if (this.additionalParams) {
            data = __assign(__assign({}, this.additionalParams), data);
        }
        var params = form_urlencoded_1.default(data);
        return {
            method: "POST",
            headers: this.prepareHeaders(),
            body: params
        };
    };
    BaseLoginManager.prototype.buildRefreshRequest = function (token) {
        var params = form_urlencoded_1.default({
            "grant_type": "refresh_token",
            "scope": this.scopes,
            "refresh_token": token.refreshToken || ""
        });
        return {
            method: "POST",
            headers: this.prepareHeaders(),
            body: params
        };
    };
    BaseLoginManager.prototype.prepareHeaders = function () {
        var headers = new Headers();
        var sec = serialize(this.client + ":" + this.secret);
        headers.append("Authorization", "Basic " + sec);
        headers.append("Content-Type", "application/x-www-form-urlencoded");
        return headers;
    };
    BaseLoginManager.prototype.notify = function (isSignedIn) {
        for (var _i = 0, _a = this.callbacks; _i < _a.length; _i++) {
            var c = _a[_i];
            c(isSignedIn);
        }
    };
    return BaseLoginManager;
}());
exports.BaseLoginManager = BaseLoginManager;
